module.exports = __webpack_public_path__ + "static/img/anxun83.c4ddeff2.png";